const GuaranteedExpertsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M46.8089 38.3017L47.2049 38.4227C48.0984 38.6957 49.0525 38.6995 49.9482 38.4337L50.3452 38.3159C51.3609 38.0146 52.4598 38.3138 53.1825 39.0885L53.465 39.3913C54.1023 40.0745 54.9267 40.5549 55.8352 40.7726L56.2379 40.8691C57.2683 41.1159 58.0703 41.9245 58.3089 42.9568L58.4021 43.3603C58.6125 44.2706 59.0862 45.0988 59.7642 45.7416L60.0647 46.0265C60.8336 46.7555 61.1239 47.8568 60.8143 48.8701L60.6933 49.2662C60.4203 50.1597 60.4165 51.1138 60.6823 52.0095L60.8 52.4065C61.1014 53.4223 60.8022 54.5211 60.0275 55.2439L59.7247 55.5264C59.0415 56.1637 58.5612 56.9881 58.3435 57.8966L58.247 58.2994C58.0001 59.3297 57.1916 60.1318 56.1593 60.3704L55.7558 60.4636C54.8455 60.6739 54.0173 61.1477 53.3745 61.8257L53.0896 62.1262C52.3606 62.8951 51.2594 63.1854 50.2461 62.8758L49.85 62.7548C48.9565 62.4818 48.0025 62.478 47.1068 62.7438L46.7098 62.8616C45.694 63.163 44.5952 62.8638 43.8724 62.089L43.5899 61.7862C42.9526 61.103 42.1283 60.6226 41.2197 60.4049L40.817 60.3084C39.7867 60.0616 38.9846 59.253 38.7461 58.2207L38.6528 57.8172C38.4425 56.9069 37.9688 56.0787 37.2908 55.4359L36.9903 55.151C36.2214 54.422 35.9311 53.3207 36.2406 52.3074L36.3616 51.9113C36.6346 51.0178 36.6385 50.0637 36.3727 49.168L36.2549 48.771C35.9535 47.7552 36.2527 46.6564 37.0275 45.9336L37.3303 45.6511C38.0134 45.0138 38.4938 44.1894 38.7115 43.2809L38.808 42.8781C39.0548 41.8478 39.8634 41.0457 40.8957 40.8072L41.2992 40.7139C42.2095 40.5036 43.0377 40.0298 43.6805 39.3518L43.9654 39.0513C44.6943 38.2824 45.7956 37.9921 46.8089 38.3017Z"
        stroke="#06AEB3"
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M48.5911 58.5262C52.982 58.5262 56.5415 54.9666 56.5415 50.5756C56.5415 46.1846 52.982 42.625 48.5911 42.625C44.2002 42.625 40.6406 46.1846 40.6406 50.5756C40.6406 54.9666 44.2002 58.5262 48.5911 58.5262Z"
        stroke="#FFA473"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.5068 53.8579L46.1057 52.8302L46.8705 49.4996L46.5363 47.5006C46.4414 46.9334 46.8811 46.4178 47.4562 46.4219C47.8743 46.4249 48.2385 46.7076 48.3451 47.1119L48.9336 49.3443L50.9604 48.81C51.5145 48.6639 52.0707 49.0385 52.1436 49.607L52.417 51.7383C52.478 52.2137 52.2123 52.6709 51.7691 52.8532L48.8987 54.0342L48.0035 55.2069"
        stroke="#FFA473"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.7086 15.6875C37.76 16.1347 37.7848 16.5886 37.7848 17.0474V24.624C37.7848 31.3591 32.3236 36.8204 25.5886 36.8204H23.8925C17.1575 36.8204 11.6963 31.3591 11.6963 24.624V17.0474C11.6963 16.5886 11.7211 16.1347 11.7725 15.6875"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M24.7825 45.929C27.1656 45.929 30.0968 38.0532 30.8072 36.04C30.838 35.9515 30.968 35.9743 30.968 36.0681V40.6668C30.968 41.2298 31.3514 41.7204 31.8969 41.8584L36.1872 42.9361"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.699 45.9216C22.3245 45.9216 19.4042 38.0457 18.6963 36.0316C18.6654 35.9437 18.5362 35.9669 18.5362 36.06V40.659C18.5362 41.2221 18.1548 41.7131 17.6108 41.8503L9.97439 43.7764C5.87443 44.8105 3 48.5106 3 52.7543V54.5019"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9727 42.2656C15.9727 42.2656 18.879 50.9311 24.6877 50.9311C30.4965 50.9311 33.4961 42.2656 33.4961 42.2656"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M24.8646 14.2974C27.8461 14.2974 37.7846 15.9472 37.7846 15.9472L40.9318 10.3219C32.3184 3.03356 24.7722 1 24.7722 1"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.6064 14.3094C21.6113 14.3094 11.6278 15.9549 11.6278 15.9549L8.46631 10.3444C17.1187 3.07511 24.6992 1.04688 24.6992 1.04688"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.4866 27.3203C38.1922 28.2297 38.6129 29.3743 38.6129 30.6166C38.6129 33.59 36.2029 36.0001 33.2296 36.0001C32.4527 36.0001 31.714 35.8361 31.0481 35.5396"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M24.699 6.34375V9.98793"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M26.5328 8.08594H22.8887"
        stroke="#027C80"
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default GuaranteedExpertsIcon;
